// extracted by mini-css-extract-plugin
export default {"-large":"Almo22HCTr0SZiy_DTf4","message":"MKDjnHM8OnGHxtA3WE2f"};